import DeckFactory from 'app/stores/decks/DeckFactory';

export default function ociDeckFactory() {
  const { widgets, layout, createWidget, newRow } = new DeckFactory('i_cloud');

  // first row
  createWidget({
    name: 'ociInventory',
    h: 7,
    w: 6,
    smallH: 4
  });
  createWidget({
    name: 'cloudTrafficOverview',
    config: { cloudFilter: 'OCI' },
    h: 7,
    w: 6,
    smallH: 4
  });
  newRow(7);

  createWidget({
    name: 'cloudTrafficProfile',
    config: { cloud_type: 'oci', cloud_region: 'All Regions' },
    h: 4,
    w: 3,
    smallH: 3
  });
  createWidget({
    name: 'cloudFlow',
    config: { cloudFilter: 'OCI' },
    h: 4,
    w: 3,
    smallH: 3
  });

  return {
    widgets,
    layout
  };
}
